var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaturesHotspot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "features-hotspot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "features-hotspot"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#007FAD",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.000000, 7.000000)",
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#FFFFFF",
    fill: "#007FAD",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 9,
    cy: 9,
    r: 5.72727273
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesHotspot);
export default __webpack_public_path__ + "static/media/features-hotspot.789b8ba3d09d85932fd6b3762963cd05.svg";
export { ForwardRef as ReactComponent };